import styled from "styled-components";
import {BottomSideSectionBox} from "../bottom-side-section.box";

export const BottomRightSectionBox = styled(BottomSideSectionBox)`
  min-width: 50%;
`